import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=3af4f5b9&"
import script from "./AppHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports